<template>
  <section class="w3l-footer-16">
    <div class="w3l-footer-16-main">
      <div class="container">
        <div class="row footer-p">
          <div class="col-lg-4 pr-lg-5">
            <!-- <a class="logo" href="/"><i class="fa fa-paw" aria-hidden="true"></i> Dogs Care</a>
              <p class="mt-4">Ensuring every lost pet makes it home safely.</p> -->
            <img
              src="@/assets/logo.png"
              alt="Sunray mascota Logo"
              class="logo"
            />
            <p class="mt-4" style="font-size: 28px">
              Ensuring every lost pet makes it home safely.
            </p>
          </div>
          <div class="vertical-line"></div>
          <div class="mt-lg-0 mt-4" style="width: 100%; flex: 1">
            <div class="row row-margin">
              <div class="col-6 column">
                <ul class="footer-gd-16">
                  <li>
                    <router-link to="/" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Home</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >About Us</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/product" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Products</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/idtags" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >My ID Tags</router-link
                    >
                  </li>
                </ul>
              </div>

              <div class="col-6 column pl-0">
                <ul class="footer-gd-16">
                  <li>
                    <router-link to="/contact" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Contact / Partner</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/policy" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Privacy Policy</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/support" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Support / FAQ</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/illustration" class="afont"
                      ><i
                        class="fa fa-paw fa-angle-right"
                        aria-hidden="true"
                      ></i
                      >Electronic User Manual</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex below-section justify-content-between align-items-center pt-4 mt-5"
        >
          <div class="columns text-lg-left">
            <p class="copy-text">
              @ 2025 Pet Id Tags. All rights reserved.
              <!-- <a
                target="_blank"
                href="http://www.petidtags.com/"
                title="PET ID TAGS"
                >PET ID TAGS</a
              > -->
            </p>
          </div>
           <div class="columns-2 mt-md-0 mt-3">
              <ul class="social">
                  <li><a href="https://www.facebook.com/profile.php?id=61576262162573&mibextid=wwXIfr&mibextid=wwXIfr" target="_blank"><span class="fab fa-facebook" aria-hidden="true"></span></a>
                  </li>
                  <li><a href="https://www.instagram.com/sunraymas?igsh=ZHZ0c2x1MDk2a2Y%3D&utm_source=qr
" target="_blank"><span class="fab fa-instagram" aria-hidden="true"></span></a>
                  </li>
                  <li><a href="https://www.youtube.com/@Sunraymascota/videos" target="_blank"><span class="fab fa-youtube" aria-hidden="true"></span></a>
                  </li>
                  <li><a href="https://www.tiktok.com/@sunraymascota" target="_blank"><span class="fab fa-tiktok" aria-hidden="true"></span></a>
                  </li>
              </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "appFooter",
};
</script>

<style lang="css">
/* 可以添加样式 */
/* 中间竖线样式 */
.vertical-line {
  width: 1px;
  background-color: #fff;
  margin: 0 20px;
}

.row-margin {
  margin-left: 100px;
  width: 500rpx;
}

.ul-font {
  font-size: 2rem;
}

.menu-li {
  font-size: 1.5rem;
}

.afont {
  font-size: 48px;
}

.logo {
  width: 180px;
  margin-bottom: 20px;
}

/* 媒体查询，适配手机屏幕 */
@media (max-width: 768px) {
  .row-margin {
    margin: 0;
  }

  .vertical-line {
    display: none;
  }

  .right {
    flex-direction: column;
    margin-top: 20px;
  }
}
</style>
